<div class="form-group dropdown">
  <label *ngIf="(label?.length > 0)">{{ label }}</label>
  <div class="input-group">
    <input #searchInput type="text" [placeholder]="placeholder"
           [formControl]="searchControl"
           class="form-control"
           (keydown)="handleKeydown($event)"
           (click)="toggleDropdown($event)"
            >
    <div class="input-group-append" *ngIf="selectedItem">
      <span class="input-group-text clear-icon" (click)="clearSelection(); $event.stopPropagation()">
        <i class="fa fa-times"></i>
      </span>
    </div>
    <div class="input-group-append arrow-btn" (click)="toggleDropdown($event);focusDropDown();">
      <span class="input-group-text">
        <i class="fas fa-chevron-down"></i>
      </span>
    </div>
  </div>
  <div class="dropdown-content" #scrollEl *ngIf="showDropdown && filteredItems.length > 0" infiniteScroll [infiniteScrollDistance]="1"  [infiniteScrollContainer]="scrollEl" [infiniteScrollThrottle]="5"   (scrolled)="onDropDownScroll()">
    <div *ngFor="let wrapped of filteredItems"
         (click)="selectItem(wrapped.model)"
         [class.highlighted]="wrapped.model === highlightedItem"
         [class.selected-top]="wrapped.isSelectedTop"
         (mouseenter)="highlightedItem = wrapped.model"
         (mouseleave)="highlightedItem = null">
      <span class="other-values">{{ wrapped.model.name }} {{ wrapped.model.altName ? '(' + wrapped.model.altName + ')' : '' }}</span>
      <i *ngIf="wrapped.model.id === selectedItem?.id" class="fa fa-check selected-check"></i>
    </div>
  </div>
</div>
